import { ModifiedLogValue, ModifiedValue } from '@lp/features/RoutePlanner/components/LogisticsChangeLog/utils';
import { ChangedFieldValue } from './ChangedFieldValue';

export const ModifiedFieldValues = ({ fieldName, changes }: Omit<ModifiedValue<ModifiedLogValue | null>, 'id'>) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-s-m text-base-5">{fieldName}:</span>
      {changes.map(({ leftValue, rightValue }) => (
        <ChangedFieldValue
          key={`${fieldName}-${leftValue?.title}-${rightValue?.title}`}
          leftValue={leftValue}
          rightValue={rightValue}
        />
      ))}
    </div>
  );
};
